import { FormattedMessage } from 'react-intl';

import messages from './PromptSave.messages';
import styles from './PromptSave.module.css';
import ConfirmationButton from '../../ui/confirmationButton/ConfirmationButton';
import { Prompt } from '../../ui/prompt';

export const PromptSave = (props) => {
    const { openPrompt, handleCancelPrompt, handleSubmitPrompt, loading } =
        props;

    if (openPrompt) {
        return (
            <Prompt className={styles.PromptSave}>
                <button onClick={handleCancelPrompt}>
                    <FormattedMessage {...messages.cancel} />
                </button>
                <ConfirmationButton
                    onClick={handleSubmitPrompt}
                    loading={loading}
                >
                    <FormattedMessage {...messages.save} />
                </ConfirmationButton>
            </Prompt>
        );
    } else {
        return null;
    }
};
